import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { RouterLink } from '@angular/router';
import { School } from '@tanzspass/shared';
import { CourseSidenavMenuComponent } from '../../course/course-sidenav-menu/course-sidenav-menu.component';
import { EventSidenavMenuComponent } from '../../event/event-sidenav-menu/event-sidenav-menu.component';
import { SchoolSidenavMenuComponent } from '../../school/school-sidenav-menu/school-sidenav-menu.component';
import { SchoolService } from '../../services/school.service';

@Component({
  selector: 'ts-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css'],
  imports: [
    MatSidenavContainer,
    MatSidenav,
    MatSidenavContent,
    RouterLink,
    CourseSidenavMenuComponent,
    MatIcon,
    EventSidenavMenuComponent,
    SchoolSidenavMenuComponent,
  ],
})
export class SidenavComponent implements OnInit, OnChanges {
  @Input() open = false;
  @Output() openedChange = new EventEmitter<boolean>();
  @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;
  public over: string;

  public school: School = new School();
  public partnerSchools: School[] = [];

  constructor(private schoolSrv: SchoolService) {}

  public openedChanged(isOpen: boolean) {
    this.openedChange.emit(isOpen);
  }

  ngOnInit() {
    this.schoolSrv.current().subscribe((school) => {
      this.school = school;
    });
    this.schoolSrv.others().subscribe((schools) => {
      this.partnerSchools = schools;
    });
  }

  ngOnChanges() {
    if (this.open) {
      this.sidenav.open();
    } else {
      this.sidenav.close();
    }
  }
}
